export default __webpack_public_path__ + "7201e6583fb99c3229b1c6d48c82956c.png";